/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'DocumentType'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('documenttype'); // main translation loaded for documenttype

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/documenttype/documenttype-dialog.html';

		return {
			/* new state for entity documentType */
			/* to access: ui-ref="documenttype.list.new" */
			/* url: hostname/documenttype/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'DocumentTypeDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'DocumentTypeFactory',
									'NewDocumentTypeFactory',
									function(DocumentTypeFactory, NewDocumentTypeFactory) {
										if (isEditMode) {
											// get the entity by its ID
											return DocumentTypeFactory.get({ id: $stateParams.documentTypeId }).$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										} else {
											// get a new empty entity
											return NewDocumentTypeFactory.get().$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for documentType new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for documentType edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('documenttype', {
		/* abstract state for entity documentType */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/documenttype',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'DocumentTypes',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('documenttype.list', {
		/* list state for entity documentType */
		/* to access: ui-ref="documenttype.list" */
		/* url: hostname/documenttype/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/documenttype/documenttypes.html',
				controller: 'DocumentTypeController',
			},
		},
	});

	$stateProvider.state('documenttype.detail', {
		/* detail state for entity documentType */
		/* to access: ui-sref="documenttype.detail" */
		/* url: hostname/documenttype/detail/:documentTypeId */
		url: '/detail/:documentTypeId',
		views: {
			'content@': {
				templateUrl: 'app/entities/documenttype/documenttype-detail.html',
				controller: 'DocumentTypeDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'DocumentTypeFactory',
				function($stateParams, DocumentTypeFactory) {
					return DocumentTypeFactory.get({ id: $stateParams.documentTypeId });
				},
			],
		},
	});

	/* url: http://<hostname>/documenttype/list/new */
	$stateProvider.state('documenttype.list.new', getNewState());
	/* url: http://<hostname>/documenttype/list/:documentTypeId/edit */
	$stateProvider.state('documenttype.list.edit', getEditState('/:documentTypeId/edit'));
	/* url: http://<hostname>/documenttype/detail/:documentTypeId/edit */
	$stateProvider.state('documenttype.detail.edit', getEditState('/edit'));

	$stateProvider.state('document.list.newDocumentType', getNewState('/documenttype/new'));
});
